import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import "./Footer.css";
import Logo from "../../assets/logo white.png"

const Footer = () => {
  return (
    <Container fluid className='footer-section'>
      <Row>
        <Col>
        <img src={Logo} alt='logo'/>
        </Col>
        <Col className='footer-content'>
        <p>
          @2024 Made by Sandun De Silva
        </p>
        </Col>
      </Row>
    </Container>
  )
}

export default Footer